import AuthorizationHelper from '@auth/services/authorization.helper';
import ModulesHelper from '@core/services/modules.helper';

export const publicSubscriptionRoutes = [
  {
    path: 'subscription-category-details/:subscriptionCategoryId',
    name: 'public-subscription-category-details',
    meta: {
      layout: 'bpc-public',
      publicRoute: true,
      entity: 'subscription-category',
    },
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "public-subscription-category-details" */ '@contacts/pages/contact-profile/profile-subscription-category-details/profile-subscription-category-details.vue'
      ),
  },
];

export const mainSubscriptionRoutes = [
  {
    path: 'subscriptions/catalog',
    name: 'admin-subscription-categories',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.subscription_categories],
      module: ModulesHelper.SUBSCRIPTIONS_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-subscription-categories" */ '@subscriptions/pages/subscription-categories/subscription-category.vue'
      ),
  },
  {
    path: 'subscriptions/subscriptions',
    name: 'admin-subscriptions',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.subscriptions],
      module: ModulesHelper.SUBSCRIPTIONS_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-subscriptions" */ '@subscriptions/pages/subscriptions/subscription.vue'
      ),
  },
  {
    path: 'subscriptions/payments-follow-up',
    name: 'admin-subscriptions-payments-follow-up',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.subscriptions],
      module: ModulesHelper.SUBSCRIPTIONS_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-subscriptions-payments-follow-up" */ '@subscriptions/pages/subscription-payment-follow-up.vue'
      ),
  },
  {
    path: 'subscriptions/direct-debits-follow-up',
    exact: false,
    name: 'admin-subscriptions-direct-debits-follow-up',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.subscriptions],
      module: ModulesHelper.SUBSCRIPTIONS_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-subscriptions" */ '@subscriptions/pages/subscription-direct-debits-follow-up.vue'
      ),
  },
  {
    path: 'memberships',
    name: 'admin-memberships',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.subscriptions],
      module: ModulesHelper.SUBSCRIPTIONS_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-memberships" */ '@subscriptions/pages/memberships/membership.vue'
      ),
  },
  {
    path: 'membership-categories',
    name: 'admin-membership-categories',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.subscription_categories],
      module: ModulesHelper.SUBSCRIPTIONS_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-subscription-categories" */ '@subscriptions/pages/admin/membership-categories.vue'
      ),
  },
  {
    path: 'membership-categories/:id',
    name: 'admin-membership-category',
    props: true,
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.subscription_categories],
      module: ModulesHelper.SUBSCRIPTIONS_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-subscription-categories" */ '@subscriptions/pages/admin/membership-category.vue'
      ),
  },
];
